import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import background from '../../public/img/bg/bg-2.png';
import { useUser } from '../../hooks';

export default function Closing() {
  const [user] = useUser();
  return (
    <div className="mt-32 w-full flex flex-row flex-wrap max-h-[444px] h-full p-4 lg:p-12">
      <div className="w-full lg:w-1/2">
        <Image
          src={background}
          alt="Tahj-Monique McCauley, Theo Knight Tomlinson and Azailiah Smith"
        />
      </div>
      <div className="w-full lg:w-1/2 flex flex-col justify-center items-center">
        <h3 className="font-bold text-3xl lg:text-5xl mx-auto text-center">
          Let's Create a Better Tomorrow{' '}
          <span className="text-cyan">Together</span>
        </h3>
        {user ? (
          <Link
            href="/profile"
            className=" mx-auto font-bold text-lg w-full py-3 px-4 bg-dark-blue text-white text-center rounded-xl max-w-[156px] shadow mt-4"
          >
            View profile
          </Link>
        ) : null}
      </div>
    </div>
  );
}
